import { JWT_NAME, configureApi } from "@inkhunt/core";
import { BACKEND_API_URL } from "../constants/constants";

/**
 * Wires the shared API client to the browser. Imported for its side effect from index.tsx
 * before the app renders.
 *
 * The post-401 navigation lives here rather than in the interceptor because it is inherently
 * platform-specific — the mobile app will push a route instead. The /login guard prevents a
 * redirect loop when the failing request came from the login page itself.
 */
configureApi({
  backendUrl: BACKEND_API_URL,
  getToken: () => sessionStorage.getItem(JWT_NAME),
  clearToken: () => sessionStorage.removeItem(JWT_NAME),
  onUnauthorized: (reason) => {
    if (!window.location.pathname.startsWith("/login")) {
      window.location.assign(`/login?logout=${encodeURIComponent(reason)}`);
    }
  },
});
